<template>
  <v-navigation-drawer
    clipped
    class="filter-drawer"
    hide-overlay
    v-model="showFilterPanel"
    app
    :width="370"
  >
    <v-toolbar class="pl-2 title primary--text " dense>
      <v-toolbar-title
        ><h2 class="text-h6">Filtre for tidsserier</h2></v-toolbar-title
      >
      <v-spacer></v-spacer>
      <v-btn title="lukk filtermeny" @click="showFilterPanel = false" icon>
        <v-icon color="primary">mdi-close-circle-outline</v-icon>
      </v-btn>
    </v-toolbar>
    <div>
      <v-row
        v-show="filtersAreLoading"
        fill-height
        justify="center"
        align="center"
      >
        <v-spacer />
        <v-col justify="center" align="center">
          <v-progress-circular
            color="primary"
            class="ma-10 mb-0"
            indeterminate
          />
          <p>Laster filter</p>
        </v-col>
        <v-spacer />
      </v-row>
    </div>

    <div class="mt-4" v-show="!filtersAreLoading">
      <div>
        <filter-drawer-welcome-message />
        <template>
          <div
            v-for="filterCategory in filters"
            v-bind:key="filterCategory.name"
          >
            <div class="filter-container mb-4" v-if="filterCategory.group">
              <v-expansion-panels flat class="grey mt-1">
                <v-expansion-panel
                  @change="focusExpansionPanelContent(filterCategory)"
                  class="grey lighten-2"
                >
                  <v-expansion-panel-header
                    ><h3 class="text-subtitle-2">
                      {{ filterCategory.group.title }}
                    </h3></v-expansion-panel-header
                  >
                  <v-expansion-panel-content class="grey lighten-3">
                    <p
                      :id="'expansion-panel-' + filterCategory.name"
                      tabindex="-1"
                      class="mt-4 pa-1"
                    >
                      {{
                        $data[filterCategory.group.conditionalProp]
                          ? filterCategory.group.enabledText
                          : filterCategory.group.disabledText
                      }}
                    </p>
                    <timeseries-filter
                      v-show="$data[filterCategory.group.conditionalProp]"
                      v-for="filter in filterCategory.filters"
                      v-bind:key="filter.title"
                      :filter="filter"
                      :filter-category="filterCategory"
                    />
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </div>
            <div
              v-else
              v-for="filter in filterCategory.filters"
              v-bind:key="filter.title"
            >
              <timeseries-filter
                :filter="filter"
                :filter-category="filterCategory"
                :standalone-filter="true"
              />
            </div>
          </div>
        </template>
        <div style="height: 20px" class="mt-4 mb-4" />
      </div>
    </div>
    <v-footer absolute class="elevation-2">
      <v-spacer></v-spacer>
      <filter-reset-dialog
        :disabled="queryExpression === '1=1'"
        style="float: right"
      ></filter-reset-dialog>
    </v-footer>
  </v-navigation-drawer>
</template>

<script>
import { TimeseriesFilter } from "@/components/index";
import { mapActions, mapState } from "vuex";
import FilterResetDialog from "../Filters/FilterResetDialog";
import FilterDrawerWelcomeMessage from "./FilterDrawerWelcomeMessage.vue";

export default {
  name: "TheFilterDrawer",
  components: {
    TimeseriesFilter,
    FilterResetDialog,
    FilterDrawerWelcomeMessage,
  },
  mounted() {
    this.setFilterDefaultValues();
  },
  data() {
    return {
      extent: Object,
      firstLoad: true,
      feltEgenskaperIsOpen: false,
      feltEgenskaperIsActive: false,
    };
  },
  computed: {
    ...mapState([
      "selectedMaaleParameter",
      "queryExpression",
      "filters",
      "filtersAreLoading",
    ]),
    showFilterPanel: {
      set(showFilterPanel) {
        this.setShowFilterPanel(showFilterPanel);
      },
      get() {
        return this.$store.state.showFilterPanel;
      },
    },
  },
  watch: {
    selectedMaaleParameter: function(newVal, oldVal) {
      if (newVal !== oldVal) {
        if (newVal.includes("Vannføring") || newVal.includes("Vannstand")) {
          this.feltEgenskaperIsActive = true;
        } else {
          this.feltEgenskaperIsActive = false;
          this.$eventHub.$emit("reset-gis-filters", {});
        }
      }
    },
  },
  methods: {
    ...mapActions(["setShowFilterPanel", "setFilterDefaultValues"]),
    focusExpansionPanelContent: function(filterCategory) {
      if (!this.feltEgenskaperIsOpen) {
        setTimeout(() => {
          document
            .getElementById("expansion-panel-" + filterCategory.name)
            .focus();
        }, 100);
      }
      this.feltEgenskaperIsOpen = !this.feltEgenskaperIsOpen;
    },
  },
};
</script>
<style>
.filter-drawer {
  z-index: 8 !important;
}

.welcome-message {
  background: white;
  border-style: solid;
  border-width: 1px;
  border-color: #cacaca;
  margin: 0px 20px 0px 20px;
  padding: 20px;
  font-weight: bold;
  border-radius: 5px;
}

.filter-container {
  padding-top: 10px;
  margin-bottom: 10px;
  margin-left: 20px;
  margin-right: 20px;
}

.filter {
  margin-left: 30px;
  margin-top: 5px;
}
</style>
